import styled from 'styled-components';
import { themeColor } from '../../../utils';
import ButtonStyle from '../ButtonStyle';
export default styled(ButtonStyle) `
  background-color: ${({ open, theme }) => themeColor('tint', open ? 'level2' : 'level1')({ theme })};

  &:hover,
  &:focus {
    background-color: ${({ theme, open }) => themeColor('tint', open ? 'level2' : 'level2')({ theme })};
  }
`;
//# sourceMappingURL=ToggleButtonStyle.js.map